/**
 * This Modules resolve problem opening select native after orientation change if it's receive a focus
 *
 * @author CorsoR
 */

class SelectNativeFocusFix {
	constructor() {
		this.bindEvent()
	}

	bindEvent() {
		window.addEventListener('orientationchange', () => this.fixFocusOnOrientantioChange())
	}

	fixFocusOnOrientantioChange() {
		const elementActive = document.activeElement
		if (elementActive && elementActive.tagName.toLocaleLowerCase() === 'select') {
			const parentElement = elementActive.parentElement
			parentElement.setAttribute('tabindex', '-1')
			parentElement.focus()
		}
	}
}

export default SelectNativeFocusFix
